// extracted by mini-css-extract-plugin
export default {"btn-grad":"Button_btn-grad__SeSor"};